<template>
  <div class="c-table" ref="planTable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table
      ref="table"
      class="common-el-table-styles"
      :data="data"
      :height="height"
      v-loading="loading"
      border
      stripe
      @sort-change="sortChange"
      @selection-change="select"
      @cell-mouse-enter="rowEnter"
      @cell-mouse-leave="rowLeave"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'convertIndex'">{{ getConvertType(scope.row[col.key]) }}</span>
          <div v-else-if="col.key === 'optStatus'">
            <i-Switch v-model="scope.row.optStatus" :true-value="1" :false-value="0" @on-change="changeActive(scope.row)" size="small" />
          </div>
          <div v-else-if="col.key === 'budget'">
            <div v-if="scope.row.editBudget">
              <el-input
                placeholder=""
                v-model="scope.row.newbudget"
                style="width: 50px"
                @blur="inputTrim('newbudget', scope.row, true)"
              ></el-input>
              <Button type="primary" :loading="saving" size="small" @click="editBudget(scope.row)">
                <span v-if="!saving">确定</span>
              </Button>
              <Button size="small" @click="cancelEdit(scope.row, 'editBudget')">取消</Button>
            </div>
            <div v-else>
              <span>{{ scope.row.budget | toThousands }}</span>
              <Icon
                v-if="scope.row.editState"
                @click="changEdit(scope.row, 'editBudget', 'budget')"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <div v-else-if="col.key === 'bid'">
            <div v-if="scope.row.editBid">
              <el-input
                placeholder=""
                v-model="scope.row.newbid"
                style="width: 50px"
                @blur="inputTrim('newbid', scope.row, true)"
              ></el-input>
              <Button type="primary" :loading="saving" size="small" @click="editBid(scope.row)">
                <span v-if="!saving">确定</span>
              </Button>
              <Button size="small" @click="cancelEdit(scope.row, 'editBid')">取消</Button>
            </div>
            <div v-else>
              <span>{{ scope.row.bidStatus === 3 ? scope.row.bid2 : scope.row.bid | toThousands }}</span>
              <Icon
                v-if="scope.row.editState"
                @click="changEdit(scope.row, 'editBid', 'bid')"
                type="md-create"
                class="g-pull-right m-edit"
                size="18"
                color="#409EFF"
              />
            </div>
          </div>
          <span v-else-if="['createTime', 'updateTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key.indexOf('Rate') > -1 || col.key.indexOf('Retain') > -1">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <betch-error v-model="betchShow" :data="betchErr" :columns="betchColumns"></betch-error>
  </div>
</template>
<script>
import { timeout, betweenTime, isEmpty, trim } from '@/common/js/utils'
import convertData from '@/data/toutiao/convert_data'
import { batchOperatorPlan, editPlanBid, editAdBudget } from '@/api/convert.model'
import BetchError from '@/components/converter/betch-error.vue'

export default {
  name: 'planTable',
  components: {
    BetchError
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Object
    },
    type: {
      type: String
    },
    height: {
      type: Number
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    editClick(row) {
      const { id } = row
      this.$router.push({ name: 'smartptomadd', query: { id, t: 'edit' } })
    },
    planClick(row) {
      const { id } = row
      this.$router.push({ name: 'smartptomplan', query: { id } })
    },
    getCpaBidType(type) {
      return type === 1 ? '期望出价' : type === 0 ? '系统推荐' : '换行测试'
    },
    getConvertType(val) {
      const convert = this.convertData.filter((ret) => ret.key === val).pop()
      if (convert) return convert.value
      return '未知'
    },
    // 开关
    changeActive(row) {
      let { adId, optStatus } = row
      if (!adId) {
        console.log(optStatus)
        this.$Message.warning({
          duration: 5,
          content: '数据有误缺少关键参数，无法操作！'
        })
        this.$emit('on-refresh')
        return
      }
      optStatus = optStatus ? 1 : 0
      if ([1, 0].includes(optStatus)) {
        this.betch(optStatus, [row])
      }
    },
    // 批量操作
    changeBetch(type) {
      const len = this.selectList.length
      if (!len) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何计划，请在列表中选择一个或多个计划再进行此操作。'
        })
        return
      }
      this.betch(type, this.selectList)
    },
    betch(type, row) {
      this.loading = true
      batchOperatorPlan({
        type,
        adIds: row
      }).then((data) => {
        if (data) {
          const { failNum, rows } = data
          if (failNum && row.length > 1) {
            // 显示错误列表
            this.betchErr = rows
            this.betchShow = true
            return
          } else if (failNum && row.length === 1) {
            this.$Message.error({
              duration: 5,
              content: rows[0].result
            })
            this.$set(row, 'optStatus', type === 0)
          } else {
            this.$Message.success({
              duration: 5,
              content: '操作成功'
            })
          }
          this.$emit('on-refresh')
        }
      })
    },
    select(val) {
      this.selectList = val
    },
    editBid(row) {
      const bid = parseFloat(row.newbid)
      // 验证
      const media = this.$store.state.Convert.media
      if (media === '10') {
        if (bid > row.budget) {
          this.$Message.error({ duration: 5, content: '出价不能大于预算值' })
          return
        }
        if (row.bidMode === 'OCPM') {
          if (!(bid >= 0.1 && bid <= 10000)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.1~10000（元）' })
            return
          }
        } else if (row.bidMode === 'CPC') {
          if (!(bid >= 0.2 && bid <= 100)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.2~100（元）' })
            return
          }
        } else if (row.bidMode === 'CPM') {
          if (!(bid >= 4 && bid <= 100)) {
            this.$Message.error({ duration: 5, content: '出价范围：4~100（元）' })
            return
          }
        } else if (row.bidMode === 'CPV') {
          if (!(bid >= 0.07 && bid <= 100)) {
            this.$Message.error({ duration: 5, content: '出价范围：0.07~100（元）' })
            return
          }
        }
      }
      if (!row.bidMode) {
        this.$Message.error({ duration: 5, content: '出价模式参数缺失，无法修改出价！' })
        return
      }
      this.saving = true
      editPlanBid({
        adAccountId: row.adAccountId,
        adId: row.adId,
        newBid: bid,
        bidMode: row.bidMode.toLowerCase()
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'editBid', false)
          this.$emit('on-refresh')
        }
      })
    },
    // 鼠标经过显示修改笔
    rowEnter(row) {
      this.$set(row, 'editState', true)
    },
    rowLeave(row) {
      this.$set(row, 'editState', false)
    },
    // 改变编辑状态
    changEdit(row, key, feild) {
      let value = row[feild]
      if (feild === 'bid' && row.bidMode === 'OCPM') value = row.bid2
      if (feild === 'bid2') {
        value = row.bid2
        feild = 'bid'
      }
      if (value < 0) value = 0
      this.data.forEach((ret) => {
        this.$set(ret, key, false)
      })
      this.$set(row, `new${feild}`, value)
      this.$set(row, key, true)
    },
    cancelEdit(row, key) {
      this.saving = false
      this.$set(row, key, false)
    },
    // 修改预算
    editBudget(row) {
      const media = this.$store.state.Convert.media
      const budget = parseFloat(row.newbudget)
      let lowBudget // 最低预算
      let totalBudget // 最低总预算

      if (media === '10') {
        // 验证
        const day = betweenTime(row.adStartTime, row.adEndTime) || 1 // 投放天数
        if (row.bidMode === 'CPM') {
          lowBudget = 100
          totalBudget = day * lowBudget
        } else {
          lowBudget = 300
          totalBudget = day * lowBudget
        }
        // budgetMode 1 -> 日预算   2 -> 总预算
        if (row.budgetMode === 1 && budget < lowBudget) {
          this.$Message.error({ duration: 5, content: `日预算应大于${lowBudget}元` })
          return
        } else if (row.budgetMode === 2 && budget < totalBudget) {
          this.$Message.error({ duration: 5, content: `总预算应大于${totalBudget}元` })
          return
        }
      }
      if (!budget || !row.adAccountId || !row.adId) {
        this.$Message.error({ duration: 5, content: '关键数据参数缺失，无法修改预算！' })
        return
      }
      this.saving = true
      editAdBudget({
        adAccountId: row.adAccountId,
        adId: row.adId,
        newAdbudget: budget
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'editBudget', false)
          this.$emit('on-refresh')
        }
      })
    },
    inputTrim(key, row, fixed) {
      let val = parseFloat(row[key])
      if (isEmpty(val) || typeof val !== 'number') {
        this.$set(row, key, 0)
        return
      }
      val = trim(val)
      if (fixed) {
        val = val * 100
        val = Math.floor(val) / 100
      } else val = parseInt(val)
      this.$set(row, key, val)
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  },
  filters: {
    adPrice: (cellValue, row) => {
      let bid = cellValue
      if (!row.bidMode) return bid
      if (row.bidMode.toLowerCase() === 'ocpm') bid = row.bid2
      return bid
    }
  },
  data() {
    return {
      saving: null, // 修改请求状态
      convertData: convertData,
      betchColumns: [],
      betchErr: [], // 批量错误
      betchShow: false, // 批量错误弹窗
      selectList: [] // 选中
    }
  },
  mounted() {
    this.betchColumns = [
      {
        key: 'mediaName',
        title: '媒体名称',
        tooltip: true,
        minWidth: 100
      },
      {
        key: 'adName',
        title: '投放计划名称',
        tooltip: true,
        minWidth: 140
      },
      {
        key: 'result',
        title: '结果',
        tooltip: true,
        minWidth: 250
      }
    ]
  }
}
</script>
